import React, { FC } from 'react'

import {
  LandingUserAge,
  LandingUserCard,
  LandingUserName,
  LandingUsersGrid,
  Photo,
  UserCardDescription,
  UserCardImage,
  UserCardSubtitle,
  UserCardTitle,
} from 'components/page/Landing/LandingView/LandingView.styled'
import { checkIsVerified } from 'components/page/Search/SearchItem/function/checkIsVerified'
import {
  Online,
  Verified,
} from 'components/presentational/photoStatus/PhotoStatus'
import { SpaceTimeLocation } from 'components/presentational/SpaceTimeLocation'
import { VerifiedSvg } from 'components/presentational/svg/VerifiedSvg'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const UsersGrid: FC = () => {
  const { landingUsers, locale } = useShallowEqualSelector(
    ({ systemReducer: { locale }, landingReducer: { landingUsers } }) => ({
      landingUsers,
      locale,
    })
  )

  if (landingUsers.length === 0) {
    return null
  }

  return (
    <LandingUsersGrid>
      {landingUsers.map((user, index) => (
        <LandingUserCard
          key={user.aid}
          target="_blank"
          to={`/${locale}/profile/${user.aid}`}
          data-name={`user-${index}`}
        >
          <UserCardImage>
            <Photo src={user.userpic} loading="lazy" />
          </UserCardImage>
          <UserCardDescription>
            <UserCardTitle>
              <LandingUserName>{user.name}</LandingUserName>
              {Boolean(user.selfAge) && (
                <>
                  <span>,</span>
                  <LandingUserAge>{user.selfAge}</LandingUserAge>
                </>
              )}
              {Boolean(user.isOnline) && <Online />}
              {checkIsVerified(user.anketaStatuses) && (
                <Verified>
                  <VerifiedSvg uid={user.aid} size={14} />
                </Verified>
              )}
            </UserCardTitle>
            <UserCardSubtitle>
              <SpaceTimeLocation statuses={user.anketaStatuses} />
            </UserCardSubtitle>
          </UserCardDescription>
        </LandingUserCard>
      ))}
    </LandingUsersGrid>
  )
}
